import React from 'react';
import { Accessor, AccessorFunction, DatumId } from '../core/Chart.types';
import { createDefaultColorScale } from './createDefaultColorScale';
import { resolveAccessor } from './resolveAccessor';

export const useGetColorAccessor = <Datum>(
  data: Datum[],
  idAccessor: Accessor<Datum, DatumId>,
  colorAccessor: Accessor<Datum, string> | undefined,
  palette: string[]
): AccessorFunction<Datum, string> => {
  const getIdentifier = React.useMemo(() => resolveAccessor(idAccessor), [idAccessor]);
  const getColor = React.useMemo(() => (colorAccessor ? resolveAccessor(colorAccessor) : null), [colorAccessor]);
  const scale = React.useMemo(
    () => (colorAccessor ? null : createDefaultColorScale(data, getIdentifier, palette)),
    [data, getIdentifier, palette, colorAccessor]
  );

  return React.useCallback(
    (datum: Datum) => (getColor ? getColor(datum) : (scale?.(getIdentifier(datum)) as string)),
    [getColor, scale, getIdentifier]
  );
};
